import classNames from 'classnames';

// styles
import s from './Badge.sss';

// consts
export const themes = {
  white: s.themeWhite,
  red: s.themeRed,
};
export const colors = {
  black: s.colorBlack,
  red: s.colorRed,
  orange: s.colorOrange,
};

// types
type BadgeProps = {
  text?: string;
  size?: number;
  color?: keyof typeof colors;
  theme?: keyof typeof themes;
  className?: string;
  isImage?: boolean
};

export const Badge: React.FC<React.PropsWithChildren<BadgeProps>> = ({
  text,
  className,
  color = 'black',
  size = 12,
  theme = 'white',
  children,
  isImage,
}) => (
  <span
    className={classNames([
      s.root,
      themes[theme],
      colors[color],
      className,
    ])}
    style={{ fontSize: size }}
  >
    {
      isImage
        ? <>{children}</>
        : <span className={s.inner}>{text}</span>
    }
  </span>
);

export default Badge;
